import { FormEvent, useState } from "react";
import { message } from "antd";
import { CORPORATE_COMPANY } from "../CorporatePortalContent";

export default function CorporateContactPage() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [content, setContent] = useState("");

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    message.success("感谢您的留言，我们会尽快与您联系。");
    setName("");
    setPhone("");
    setCompany("");
    setContent("");
  };

  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">联系我们</h1>
          <p className="corporate-page-banner-desc">
            欢迎预约产品演示或行业方案交流，我们将在 1 个工作日内与您联系。
          </p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <div className="corporate-contact-grid">
            <div className="corporate-card">
              <h3 className="corporate-card-title">公司信息</h3>
              <p className="corporate-card-text" style={{ marginBottom: 16 }}>
                {CORPORATE_COMPANY.fullName}
              </p>
              {CORPORATE_COMPANY.email ? (
                <p className="corporate-card-text">邮箱：{CORPORATE_COMPANY.email}</p>
              ) : null}
            </div>

            <form className="corporate-card corporate-form-card" onSubmit={onSubmit}>
              <h3 className="corporate-card-title">在线留言</h3>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="您的姓名"
                required
              />
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="联系电话"
                required
              />
              <input
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder="公司名称"
              />
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="请描述您的业务场景或合作需求"
                required
              />
              <button type="submit" className="corporate-btn corporate-btn-primary">
                提交留言
              </button>
            </form>
          </div>
        </section>
      </div>
    </>
  );
}
